export default {"src":"/_next/static/media/nav.4e480e2e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};